import { Injectable, signal, computed } from '@angular/core';

/** Tracks the number of in-flight HTTP requests for the global loader. */
@Injectable({ providedIn: 'root' })
export class LoadingService {
  private readonly count = signal(0);

  /** True whenever at least one HTTP request is in progress. */
  readonly isLoading = computed(() => this.count() > 0);

  start(): void {
    this.count.update((n) => n + 1);
  }

  stop(): void {
    this.count.update((n) => Math.max(0, n - 1));
  }
}